// extracted by mini-css-extract-plugin
export default {"headingContainer":"PageHeading_headingContainer__c8ryK","backButton":"PageHeading_backButton__T9Vru","heading":"PageHeading_heading__ewceW"};